import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { reverse } from 'named-urls';
import { useNavigate } from 'react-router-dom';

import CommonTable from '../../common/components/CommonTable';
import CommonLoader from '../../common/components/CommonLoader';
import UsersTableRow from './UsersTableRow';
import { SET_USER_SEARCH_STATE } from '../UsersReducer';
import RouterPaths from '../../constants/RouterPaths';

const TABLE_HEADERS = [
  { label: 'ID' },
  { label: 'First name' },
  { label: 'Last name' },
  { label: 'Email address' },
  { label: 'Registered date' },
  { label: 'Dealer' },
  { label: 'Status' },
  { label: 'Postal code' },
  { label: 'Actions', className: 'text-right action-table-th' },
];

function UsersTable({ data, offset, changeOffset, searchParams }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isLoading = useSelector((state) => state.users.get('loaderStatus'));

  const handleRowClick = (user) => {
    dispatch({
      type: SET_USER_SEARCH_STATE,
      payload: {
        userId: user.id,
        searchParams,
      },
    });

    navigate(reverse(RouterPaths.EDIT_USER, { id: user.id }));
  };

  return (
    <Row>
      <Col xs="12">
        <CommonLoader status={isLoading}>
          <CommonTable
            rowIdPrefix="user-row"
            rowComponent={UsersTableRow}
            data={data}
            offset={offset}
            onOffsetChange={changeOffset}
            headers={TABLE_HEADERS}
            title="Users"
            onRowClick={handleRowClick}
          />
        </CommonLoader>
      </Col>
    </Row>
  );
}

UsersTable.propTypes = {
  data: PropTypes.array.isRequired,
  offset: PropTypes.number.isRequired,
  changeOffset: PropTypes.func.isRequired,
};

export default UsersTable;
